module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct1",
    attrs: {
      "id": "d7e225622"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Inc_9781418557720_epub_c8_r1#Anch00522",
      "id": "Anch0048"
    }
  }, [_vm._v("Dealing with Anger "), _c('br'), _c('b', [_vm._v("Counting to Ten")])])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e226422"
    }
  }, [_c('i', [_vm._v("“Be angry, and do not sin”: Do not let the sun go down on your ")]), _c('i', [_vm._v("wrath.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e227222"
    }
  }, [_c('i', [_vm._v("—Ephesians 4:26 ")]), _c('i', [_vm._v("NKJV ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e228122"
    }
  }, [_vm._v("Have you ever felt angry toward a person or situation and wondered if your feelings were appropriate? Has your anger ever caused you to say or do something you later regretted? You’re not alone. Anger is a universally expressed human emotion. It also happens to sit near the top of the least-comfortable-feelings list.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e230222"
    }
  }, [_vm._v("You have heard it said that when you’re nearing the boiling point you should count to ten. Only one small problem: In the middle of your frustration, you probably prefer to count backward. “Ten . . . nine . . . eight . . . seven . . . six . . . five . . . four . . . three . . . two . . . one . . . "), _c('i', [_vm._v("boom!")]), _vm._v(" Angry countdowns rarely end with a calm, relaxed resolution. They usually end in disaster.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e233122"
    }
  }, [_vm._v("Or maybe instead of overreacting in anger, you try to ignore your very real feelings. Perhaps you bottle up anger and hope it goes away. But it doesn’t go away; it hangs around. Bottled-up anger actually stays “fresh” longer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e234522"
    }
  }, [_vm._v("What can you do? How should you respond when someone or something triggers your anger switch? First, take time to examine the situation before responding. Is this something that warrants a response? What kind of response? Are you simply frustrated, or does your anger stem from a desire to right a wrong? A quick temper tries to make things right too soon and may escalate rather than solve the situation. If you have a tendency to react in anger, pray for patience. Allow yourself time to understand.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e238823"
    }
  }, [_vm._v("Then carefully consider your next step. Perhaps you can work things out through a calm discussion. Maybe you need to step away from the situation—create some space so you don’t respond inappropriately. Or maybe you should invite a third party to help bring a new perspective to the situation.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e240623"
    }
  }, [_vm._v("You’ll need good judgment in order to resolve your anger. And resolution is the key to dealing with anger appropriately. Paul emphasized this when he wrote: “Do not let the sun go down while you are still angry.” You probably know from experience how damaging unresolved anger can be. Don’t get stuck there. If you are attempting to right a wrong, bathe your attitude and thoughts in love before confronting the object of your anger—and then do so as soon as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e243823"
    }
  }, [_vm._v("Your final step is to look inward. Maybe there’s a lesson in this for you. Do you need to build perseverance? grow tolerance? develop a gentle spirit? God has filled your life with opportunities to grow—both in your understanding of the human condition, and in your relationship with Him. Seek God’s truth in the middle of your anger, and growth will be assured.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89af3d08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inc_9781418557720_epub_c17_r1.vue
// module id = 99
// module chunks = 0